<template>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="!loading_list">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text text-primary">{{ responseData.event.name }}<br>{{ page_title }}</h3>
        </div>
    </div>
    
    <div class="section" v-if="!loading_list">
        <div class="row mt-1" v-if="responseData.count_total">
            <h4 class="text-left text-primary" v-if="!loading_list">{{ $t('registration_summary') }}</h4>
            <div class="col-12" v-if="responseData.count_total.main_total">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('total') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.main_total_coming : '00' }}</span>{{responseData.count_total.main_total_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.main_total : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.main_male">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('male') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.main_male_coming : '00' }}</span>{{responseData.count_total.main_male_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.main_male : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.main_female">
                <div class="stat-box">
                    <div class="title">{{ $t('female') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.main_female_coming : '00' }}</span>{{responseData.count_total.main_female_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.main_female : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.main_male_member">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('male_members') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.main_male_member_coming : '00' }}</span>{{responseData.count_total.main_male_member_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.main_male_member : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.main_female_member">
                <div class="stat-box">
                    <div class="title">{{ $t('female_members') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.main_female_member_coming : '00' }}</span>{{responseData.count_total.main_female_member_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.main_female_member : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-4 mt-1" v-if="responseData.count_total.wing_1_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('wisdom') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_1_coming_count : '00' }}</span>{{responseData.count_total.wing_1_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_1_count : '00' }}</span>
                    </div>
                </div>
            </div>

            <div class="col-4 mt-1" v-if="responseData.count_total.wing_2_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('youth') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_2_coming_count : '00' }}</span>{{responseData.count_total.wing_2_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_2_count : '00' }}</span>
                    </div>
                </div>
            </div>

            <div class="col-4 mt-1" v-if="responseData.count_total.wing_3_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('students') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_3_coming_count : '00' }}</span>{{responseData.count_total.wing_3_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_3_count : '00' }}</span>
                    </div>
                </div>
            </div>

            <div class="col-4 mt-1" v-if="responseData.count_total.wing_4_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('women') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_4_coming_count : '00' }}</span>{{responseData.count_total.wing_4_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_4_count : '00' }}</span>
                    </div>
                </div>
            </div>

            <div class="col-4 mt-1" v-if="responseData.count_total.wing_6_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('girls') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_6_coming_count : '00' }}</span>{{responseData.count_total.wing_6_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_6_count : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-4 mt-1" v-if="responseData.count_total.wing_5_count">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('balavedi') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.wing_5_coming_count : '00' }}</span>{{responseData.count_total.wing_5_coming_count?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.wing_5_count : '00' }}</span>
                    </div>
                </div>
            </div>

            <h4 class="text-left text-primary mt-1" v-if="!loading_list">{{ $t('participants_summary_with_family') }}</h4>
            <div class="col-12" v-if="responseData.count_total.total">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('total') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.total_coming : '00' }}</span>{{responseData.count_total.total_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.total : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.male">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('male') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.male_coming : '00' }}</span>{{responseData.count_total.male_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.male : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.female">
                <div class="stat-box">
                    <div class="title">{{ $t('female') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.female_coming : '00' }}</span>{{responseData.count_total.female_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.female : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.male_member">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('male_members') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.male_member_coming : '00' }}</span>{{responseData.count_total.male_member_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.male_member : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.count_total.female_member">
                <div class="stat-box">
                    <div class="title">{{ $t('female_members') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total ? responseData.count_total.female_member_coming : '00' }}</span>{{responseData.count_total.female_member_coming?'/':''}}<span class="text-danger">{{ responseData.count_total ? responseData.count_total.female_member : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.sweet_buds && responseData.count_total.sweet_buds">
                <div class="stat-box">
                    <div class="title">{{ $t('sweet_buds') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total.sweet_buds_coming ? responseData.count_total.sweet_buds_coming : '00' }}</span>{{responseData.count_total.sweet_buds_coming?'/':''}}<span class="text-danger">{{ responseData.count_total.sweet_buds ? responseData.count_total.sweet_buds : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.butterflies && responseData.count_total.butterflies">
                <div class="stat-box">
                    <div class="title">{{ $t('butterflies') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total.butterflies_coming ? responseData.count_total.butterflies_coming : '00' }}</span>{{responseData.count_total.butterflies_coming?'/':''}}<span class="text-danger">{{ responseData.count_total.butterflies ? responseData.count_total.butterflies : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.little_wings && responseData.count_total.little_wings">
                <div class="stat-box">
                    <div class="title">{{ $t('little_wings') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total.little_wings_coming ? responseData.count_total.little_wings_coming : '00' }}</span>{{responseData.count_total.little_wings_coming?'/':''}}<span class="text-danger">{{ responseData.count_total.little_wings ? responseData.count_total.little_wings : '00' }}</span>
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.teenspace && responseData.count_total.teenspace">
                <div class="stat-box">
                    <div class="title mal-text">{{ $t('teenspace') }}</div>
                    <div class="value text-dark"><span class="text-success">{{ responseData.count_total.teenspace_coming ? responseData.count_total.teenspace_coming : '00' }}</span>{{responseData.count_total.teenspace_coming?'/':''}}<span class="text-danger">{{ responseData.count_total.teenspace ? responseData.count_total.teenspace : '00' }}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-4 mt-1" v-if="responseData.event.permissions.kids && responseData.count_total.y13">
                <div class="stat-box">
                    <div class="title mal-text">1-3Y</div>
                    <div class="value text-info">{{ responseData.count_total.y13 ? responseData.count_total.y13 : '00' }}
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.kids && responseData.count_total.y48">
                <div class="stat-box">
                    <div class="title mal-text">4-8Y</div>
                    <div class="value text-primary">{{ responseData.count_total.y48 ? responseData.count_total.y48 : '00' }}
                    </div>
                </div>
            </div>
            <div class="col-6 mt-1" v-if="responseData.event.permissions.kids && responseData.count_total.y914">
                <div class="stat-box">
                    <div class="title mal-text">9-14Y</div>
                    <div class="value text-danger">{{ responseData.count_total.y914 ? responseData.count_total.y914 : '00' }}
                    </div>
                </div>
            </div> -->
        </div>
        <div class="text-danger" v-if="responseData.summary_report_note && responseData.count_total">{{ responseData.summary_report_note }}</div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">{{ $t('no_members_added') }}</h4>
    </div>
    <div class="section mt-2 mb-2" v-if="!loading_list">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">{{ $t('name') }}</th>
                            <th scope="col">{{ $t('male') }}</th>
                            <th scope="col">{{ $t('female') }}</th>
                            <th scope="col">{{ $t('total') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sub_level in member_lists" v-bind:key="sub_level">
                            <td class="text-primary font-dark">
                                <router-link v-if="(user_level <= 2 && responseData.district_permition_list.length) || user_level <= 2"
                                    :to="'/event/' + $route.params.slug + '/summary-report/'+(user_level +1)+'/' + sub_level.id +'/'+this.$route.params.event_id + ''">
                                    {{ sub_level.name }}
                                </router-link>
                                <router-link v-if="user_level == 3" :to="'/'">
                                    {{ sub_level.name }}
                                </router-link>
                            </td>
                            <td class="text-primary font-dark">
                                {{ sub_level.event_reg.male_coming }}{{ sub_level.event_reg.male_coming?'/':'' }}{{ sub_level.event_reg.male }}
                            </td>
                            <td class="text-primary font-dark">
                                {{ sub_level.event_reg.female_coming }}{{ sub_level.event_reg.female_coming?'/':'' }}{{ sub_level.event_reg.female }}
                            </td>
                            <td class="text-primary font-dark">
                                {{ sub_level.event_reg.total_coming }}{{ sub_level.event_reg.total_coming?'/':'' }}{{ sub_level.event_reg.total }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import UserService from "../../services/user.service";
import $ from 'jquery';
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: 'Nerpatham Report',
    components: {
        AlertModel,
        DialogModel
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            user_level: "",
            user_level_id: "",
            sub_levels: [],
            member_lists: [],
            member_list: [],
            permissions: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            attendance_present: [],
            attendance_absent: [],
            level: [],
            page_title: 'റിപ്പോർട്ട്',
            responseData: {
                event: {
                    permissions:[]
                },
                count_total: [],
                district_permition_list:[]
            }


        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        minusToZero() {
            let value = this.count_target - this.count_total;
            if (value <= 0) {
                return '0';
            } else {
                return value;
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.user_level);
            this.user_level_id = parseInt(this.$route.params.id);
            this.getMembersList();
            this.$root.updateParent(this.$t('event_registration_report'));
        }

        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getMembersList() {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                user_level_id: this.user_level_id,
                event_type: this.$route.params.slug,
                event_id: this.$route.params.event_id
                
            }
            UserService.authPostRequest(`get-event-summary-report`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.responseData = response.data.data;
                        this.member_lists = response.data.data.list;
                        this.level = response.data.data.level;
                        this.count_target = response.data.data.count_target;
                        this.count_total = response.data.data.count_total;
                        this.level = response.data.data.level;
                        this.target_title = response.data.data.target_title;
                        this.page_title = response.data.data.page_title;
                        this.$root.updateParent(this.responseData.event.name+' Summary');
                        this.loading_list = false;
                        
                        // this.updateChart();
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        }
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;

}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    height: auto;
}

.left {
    margin-left: 20px;
}

.wallet-card {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 0px 16px;
    position: relative;
    z-index: 1;
}

.bg-pink {
    background-color: #E6A6C7 !important;
}

.bg-pink-dark {
    background-color: #B85887 !important;
}
</style>